// Common short functions that don't warrant their own module

export const friendlyMapName = name => {
    if (name === 'Erangel_Main') return 'Erangel'
    if (name === 'Baltic_Main') return 'Erangel'
    if (name === 'Desert_Main') return 'Miramar'
    if (name === 'Savage_Main') return 'Sanhok'
    if (name === 'DihorOtok_Main') return 'Vikendi'
    if (name === 'Summerland_Main') return 'Karakin'
    if (name === 'Chimera_Main') return 'Paramo'
    if (name === 'Heaven_Main') return 'Haven'
    if (name === 'Tiger_Main') return 'Taego'
    if (name === 'Kiki_Main') return 'Deston'
    if (name === 'Neon_Main') return 'Rondo'
    return name
}

/** Display name (Admin dropdown) -> internal asset name for map image and sizes */
export const toInternalMapName = name => {
    if (!name || typeof name !== 'string') return 'Erangel_Main'
    const n = name.trim()
    if (n === 'Erangel') return 'Erangel_Main'
    if (n === 'Miramar') return 'Desert_Main'
    if (n === 'Sanhok') return 'Savage_Main'
    if (n === 'Vikendi') return 'DihorOtok_Main'
    if (n === 'Rondo') return 'Neon_Main'
    if (n === 'Karakin') return 'Summerland_Main'
    if (n === 'Taego') return 'Tiger_Main'
    if (n === 'Deston') return 'Kiki_Main'
    // Already internal?
    if (n.endsWith('_Main')) return n
    return 'Erangel_Main'
}



// WEBPACK FOOTER //
// ./src/lib/util.js